import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid, TextField } from '@material-ui/core';

import helpers from 'app/utils/helpers';
import companyEndpoints from 'app/api/services/companyEndpoints';

import InfoRequest from '../InfoRequest';
import VehicleTableAdd from 'app/components/ServicesForms/Licenses/commonComponents/VehicleTableAdd';
import { clearVehicleListToLicensesDuplicate } from 'app/utils/forms/services/licenses';

function CompanyName(props) {
  const { classes, values, setFieldValue, oldRequest, oldLicense } = props;

  const [vehicles, setVehicles] = useState([]);
  const [vehiclesOld, setVehiclesOld] = useState([]);
  
  const [companyData, setCompanyData] = useState({});
  const [oldCompanyData, setOldCompanyData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      if (oldRequest.cdEmpresa) {
        const responseOld = await companyEndpoints.getLastChangesCompany(oldRequest.cdEmpresa);

        if (responseOld.status === 200) {
          let oldData = responseOld.data || '';
          let nmCompany = oldData.cdTipoPessoaFisica
            ? oldData.nmCompleto || null
            : oldData.deRazaoSocial || null;
            
          if(oldData === ''){
            oldData = oldLicense;
            nmCompany = oldData.nmCompleto || oldData.deRazaoSocial || null;
          }else{
            nmCompany = oldData.cdTipoPessoaFisica
            ? oldData.nmCompleto || null
            : oldData.deRazaoSocial || null;
          }

          if (nmCompany) {
            setFieldValue('nmCompletoAnterior', nmCompany);
          }
          setOldCompanyData(oldData);
        }
        const response = await companyEndpoints.getCompany({ cdEmpresa: oldRequest.cdEmpresa });
        if (response.status === 200 && response.data) {
          setCompanyData(response.data);
        }
      }
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldRequest]);

  useEffect(() => {
    const init = async () => {
      if (values.licencaVeiculos && values.licencaVeiculos.length > 0) {
        setVehicles(values.licencaVeiculos);
      } else {
        if (oldLicense?.licencaVeiculos) {
          const list = clearVehicleListToLicensesDuplicate(oldLicense?.licencaVeiculos);
          setVehicles(list);
          setFieldValue('licencaVeiculos', list);
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldLicense]);

  const handleChangeLists = (list, type) => {
    // eslint-disable-next-line default-case
    switch (type) {
      case 'vehicles':
        setVehicles(list);
        setFieldValue('licencaVeiculos', list);
        break;
    }
  };
  
  useEffect(() => {
    const init = () => {
      if (oldLicense?.licencaVeiculos) {
        setVehiclesOld(oldLicense.licencaVeiculos);
      }
    };
    init();
  }, [oldLicense]);

  if (loading) {
    return (
      <Grid item xs={12} className={classes.centerProgress}>
        <CircularProgress size={18} />
      </Grid>
    );
  }

  return (
    <>
      <InfoRequest {...props} oldCompanyData={oldCompanyData} />

      <Grid item xs={12}>
        <h3 className={classes.greenTitle}>Informações NOVAS na licença</h3>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="Nome / Razão Social"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={
            companyData.deRazaoSocial && companyData.deRazaoSocial !== '' ? companyData.deRazaoSocial : companyData.nmCompleto
          }
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="CNPJ / CPF"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={helpers.formatarDocumento(
            companyData.cdTipoPessoaFisica
              ? companyData.deCpf || companyData.deCpfCnpj || ''
              : companyData.deCnpjMatriz || ''
          )}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <VehicleTableAdd
          {...props}
          classes={classes}
          oldVehicles={vehiclesOld}
          data={vehicles}
          setData={list => handleChangeLists(list, 'vehicles')}
          hideDeleteButton={true}
          hideAddButton={true}
        />
      </Grid>

    </>
  );
}

export default CompanyName;
